import getWithToken from './base/get-with-token'

const getTopFourNightFlowCustomer = (date, searchData) => getWithToken(`/dashboard/top-four-night-flow-customer?date=${date}`)(searchData)

export default getTopFourNightFlowCustomer